module.exports = __webpack_public_path__ + "assets/logo-lg.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo-lg.png
// module id = 1104
// module chunks = 7